import { Avatar, Button, keyframes, Stack, Typography } from '@mui/material';
import { DocumentsContext } from 'Context/DocumentsContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { PurpleSortIcon } from 'Images';
import { useContext, useState } from 'react';
import { DocumentAmount } from './DocumentAmount';
import { DOCUMENTS_REDUCER_CASE } from 'Enum/documents';

export const OrderByNewOld = () => {
  const { filter, setFilter, dispatchDocuments } = useContext(DocumentsContext);
  const [isClicked, setIsClicked] = useState<boolean>(false);

  const rotate = keyframes`from{ transform: rotate(0deg); } to{ transform: rotate(180deg); }`;

  const orderByHandler = () => {
    const updatedFilter = {
      ...filter,
      orderByDescending: !filter.orderByDescending,
    };
    setFilter(updatedFilter);
    dispatchDocuments({
      type: DOCUMENTS_REDUCER_CASE.FILTER,
      payload: {
        value: { filter: updatedFilter },
      },
    });
    setIsClicked(true);
    setTimeout(() => {
      setIsClicked(false);
    }, 250);
  };

  return (
    <Stack direction='row' alignItems='center' justifyContent='space-between'>
      <DocumentAmount />
      <Button
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
        }}
        onClick={orderByHandler}
      >
        <Avatar
          alt=''
          src={PurpleSortIcon}
          sx={{
            width: '24px',
            height: '24px',
            animation: isClicked ? `${rotate} .2s linear` : undefined,
          }}
        />
        <Typography variant='body2'>
          {Dictionary[DICTIONARY.Documents].sort(filter.orderByDescending)}
        </Typography>
      </Button>
    </Stack>
  );
};
